import React from "react";
import { EDSButton } from "../../../eds/EDSButton";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../../ui/dialog";

type InfoModalTypes = {
  isOpen: boolean;
  onAction: any;
  children: React.ReactNode;
  actions: any;
  title: string;
};

export const InfoModal = ({
  title,
  isOpen,
  actions,
  onAction,
  children
}: InfoModalTypes) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onAction("close")}>
      <DialogContent className="InfoModal max-w-[400px] min-w-[300px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">
            Information dialog
          </DialogDescription>
        </DialogHeader>
        <div className="InfoModal__content my-4 overflow-y-auto max-h-[80vh]">
          {children}
        </div>
        {actions && actions.length > 0 && (
          <DialogFooter className="InfoButtons flex flex-row gap-2 justify-end">
            {actions.map(
              (action: {
                text: string;
                name: string;
                type: "default" | "primary" | "secondary";
              }) => (
                <EDSButton
                  className="InfoModalButton min-w-[100px]"
                  key={action.name}
                  variant={
                    action.type === "primary"
                      ? "default"
                      : action.type === "secondary"
                        ? "secondary"
                        : "outline"
                  }
                  onClick={() => {
                    onAction(action.name);
                  }}
                >
                  {action.text}
                </EDSButton>
              )
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
